import { DropdownWithSearch } from "InnoUI/innoinput";
import { calendarDays, timeTosend } from "utils/optionData/utils";

const TimeToSendDropdown = ({
  onChange = () => {},
  defaultValue,
  disabled = true,
  name,
  disabledDropdown,
  active,
}) => {
  const Options = timeTosend.map((data) => ({
    id: data.id,
    label: data.label,
  }));

  const handleDropdownChange = (value) => {
    const selectedOption = Options.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.label : "";
    onChange(name, selectedLabel, active);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      options={Options}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={disabled}
      width="100%"
      dropdowType={name}
      placeholder="Select Time"
      height="32px"
      disabledDropdown={disabledDropdown}
    />
  );
};

export default TimeToSendDropdown;
